'use client';

import { Bag } from 'mmds';
import useCart from '@app/[lang]/cart/state';
import s from './cart-indicator.module.css';

const CartIndicator = () => {
    const { cartItemsCount } = useCart((state) => ({
        cartItemsCount: state.cartItemsCount,
    }));

    return (
        <>
            <Bag />
            {!!cartItemsCount && <span className={s.dot}></span>}
        </>
    );
};

export default CartIndicator;
